import clientConfig from "../../template/clientConfig";

const buildConfiguration = config => {
  if (clientConfig.isLocal()) {
    return {
      postMessageUrl: config.SDK_POST_MESSAGE_URL,
      bagApiUrl: config.SDK_BAG_API_URL,
      paymentOptionsApiUrl: config.SDK_PAYMENT_OPTIONS_API_URL,
      productCatalogueApiUrl: config.SDK_PRODUCT_CATALOGUE_API_URL,
      subscriptionOptionsApiUrl: config.SDK_SUBSCRIPTION_OPTIONS_API_URL,
      xSiteOrigin: config.SDK_X_SITE_ORIGIN,
      savedItemsApiUrl: config.SDK_SAVED_ITEMS_API_URL
    };
  }

  return {
    xSiteOrigin: clientConfig.getXSiteOrigin()
  };
};

export const getConfiguration = () => buildConfiguration(clientConfig.get());



// WEBPACK FOOTER //
// ./client/sdk/configuration.js